export default "__VITE_ASSET__26c8dc0f__"